import React from 'react';

import CurrentUser from '@scripts/utilities/current-user.js';


// a global state object shared across all instances to determine whether the
// trading view script has been loaded into the page.
var scriptLoaded = false;

// a global state object for ensuring the id's for the trading view charts are
// unique.
var chartId = 1;


class TradingViewChart extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      scriptLoaded: scriptLoaded,
      id: 'tradingview-chart-' + chartId++
    };

    this.onLoad = this.onLoad.bind(this);
  }

  initialiseChart() {
    var chartInstance = new TradingView.widget({
      "autosize": true,
      "symbol": this.props.symbol,
      "interval": "D",
      "timezone": "Etc/UTC",
      "theme": "light",
      "style": "1",
      "locale": "en",
      "enable_publishing": false,
      "allow_symbol_change": true,
      "container_id": this.state.id
    });
  }
  
  onLoad() {
    this.initialiseChart();

    this.setState({ scriptLoaded: true });
    scriptLoaded = true;
  }

  /**
   * Load the trading view chart into the document.
   */
  loadScript() {
    var script = document.createElement('script');
    script.addEventListener('load', this.onLoad);
    script.src = 'https://s3.tradingview.com/tv.js';
    script.async = true;
    document.head.appendChild(script);
  }

  componentDidMount() {
    if (! this.state.scriptLoaded) {
      this.loadScript();
    } else {
      this.initialiseChart()
    }
  }

  render() {
    var content = [];

    content.push(
      <div key="chart" className="cs-block-tradingview-chart__wrapper">
        <div className="cs-block-tradingview-chart__container">
          <div id={this.state.id} className="cs-block-tradingview-chart__chart" />
        </div>
      </div>
    );
    content.push(
      <div key="copyright" className="tradingview-widget-copyright">
        <a href="https://www.tradingview.com/" rel="noopener" target="_blank">Chart by TradingView</a>
      </div>
    );
    return content;
  }
}


export default TradingViewChart;

